import styled from 'styled-components';

export const IconContainer = styled.div`
  height: 20px;
  width: 16px;
  display: flex;
  align-items: center;
  margin-right: 4px;
`;

export const SubtitleBlock = styled.span<{ $active?: boolean }>`
  font-size: 12px;
  line-height: 16px;
  color: ${({ $active }) => ($active ? '#007AFF' : '#919499')};
  padding-right: 8px;
`;

export const TitleBlock = styled.div`
  display: flex;
  align-items: start;
`;

export const LabelText = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
`;
